import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'convertBRToNewLine'
})
export class ConvertBRToNewLinePipe implements PipeTransform {
    transform(value : string) : string {
        if (value) {
            return value.replace(/\s?(<br\s?\/?>)\s?/g, "\r\n")
        }
        return ''
    }
}
